/* app/js/src/components/graphics/edit/edit-graphics-main.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.scrollable::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.scrollable::-webkit-scrollbar-corner {
  background: transparent;
}
.scrollable::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.scrollable::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  padding-top: 15px;
  padding-left: 39px;
  overflow-y: hidden;
}
header {
  font-size: 20px;
  color: #232f3a;
  margin-bottom: 21px;
}
.scrollable {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: scroll;
  background-color: #f1f3f4;
  height: 100%;
}
/*# sourceMappingURL=edit-graphics-main.component.css.map */
